export default __webpack_public_path__ + "static/media/92_photo.5db85553.jpg";